import PropTypes from "prop-types";

import { iconMapping } from "../utils/getIconNameFromNotification";

const propTypes = {
  category: PropTypes.string,
};

function NotificationIcon({ category, ...props }) {
  if (!category) {
    return null;
  }

  const icon = iconMapping[category] || "disruption";

  return (
    <div className="notification-icon" {...props}>
      <img alt={category} src={`/static/${icon}.png`} width="100%" />
    </div>
  );
}

NotificationIcon.propTypes = propTypes;

export default NotificationIcon;
